module.exports = {"370481001":"荆河街道","370481002":"龙泉街道","370481003":"北辛街道","370481004":"善南街道","370481100":"东沙河镇","370481101":"洪绪镇","370481102":"南沙河镇","370481103":"大坞镇","370481104":"滨湖镇","370481105":"级索镇","370481106":"西岗镇","370481107":"姜屯镇","370481108":"鲍沟镇","370481109":"张汪镇","370481110":"官桥镇","370481111":"柴胡店镇","370481112":"羊庄镇","370481113":"木石镇","370481114":"界河镇","370481115":"龙阳镇","370481116":"东郭镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370481.json
// module id = 1283
// module chunks = 0